import {clearSession, writeNewToken} from "../service/authService/AuthService";
import {removeUserRefreshToken, removeUserToken} from "../service/localStorage/LocalStorageService";

export const actionTypes = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    REFRESH_ROLES: 'REFRESH_ROLES',
}

export const initialState = {
    loading: true,
    role: []
}

export function reducer(state, action) {

    switch (action.type) {
        case actionTypes.LOGIN: {
            writeNewToken(action.token)
            return {
                ...state,
                loading: false,
                loginState: true,
                role: action.roles,
                // role: [],
            }
        }
        case actionTypes.LOGOUT: {
            clearSession()
            removeUserToken()
            removeUserRefreshToken()
            return {
                ...state,
                loading: false,
                loginState: false,
                role: []
            }
        }
        case actionTypes.REFRESH_ROLES: {
            return {
                ...state,
                loading: false,
                loginState: true,
                role: action.roles
            }
        }
        default: {
            clearSession()
            removeUserToken()
            removeUserRefreshToken()
            return {
                ...state,
                loading: false,
                loginState: false,
                role: []
            }
        }
    }
}

export function setLoginStateDispatch(actionType, token = null, permissions) {
    return {
        type: actionType,
        token: token,
        roles: permissions
    }
}


export const AdminRoles = {
    "SUPER_ADMIN": {
        role: "SUPER_ADMIN",
        name: "مدیر کل"
    }, "FUND_MANAGER": {
        role: "FUND_MANAGER",
        name: "مدیر صندوق"
    }, "SITE_MANAGER": {
        role: "SITE_MANAGER",
        name: "مدیر سایت"
    }, "READ_ADMINS_LIST": {
        role: "READ_ADMINS_LIST",
        name: "خواندن لیست مدیران"
    }, "READ_FILES_LIST": {
        role: "READ_FILES_LIST",
        name: ""
    }, "READ_ADMIN_OWN_INFORMATION": {
        role: "READ_ADMIN_OWN_INFORMATION",
        name: ""
    }, "READ_LOCATIONS_LIST": {
        role: "READ_LOCATIONS_LIST",
        name: ""
    }, "READ_LOCATION_CATEGORY_TREE": {
        role: "READ_LOCATION_CATEGORY_TREE",
        name: ""
    }, "CREATE_ADMIN_ROLE": {
        role: "CREATE_ADMIN_ROLE",
        name: ""
    }, "READ_CLERKS_LIST": {
        role: "READ_CLERKS_LIST",
        name: ""
    }, "READ_LANGUAGES_LIST": {
        role: "READ_LANGUAGES_LIST",
        name: ""
    }, "READ_RESIDENCES_LIST": {
        role: "READ_RESIDENCES_LIST",
        name: ""
    }, "READ_ACCOMMODATION_PERIODS_LIST": {
        role: "READ_ACCOMMODATION_PERIODS_LIST",
        name: ""
    }, "READ_ITIKAF_PERIOD_INFORMATION": {
        role: "READ_ITIKAF_PERIOD_INFORMATION",
        name: ""
    }, "READ_MAWKIB_PERIODS_LIST": {
        role: "READ_MAWKIB_PERIODS_LIST",
        name: ""
    }, "READ_PAYMENT_TRASACTIONS_LIST": {
        role: "READ_PAYMENT_TRASACTIONS_LIST",
        name: ""
    }, "READ_ACCOMMODATION_REQUEST_STATUS_STATISTICAL": {
        role: "READ_ACCOMMODATION_REQUEST_STATUS_STATISTICAL",
        name: ""
    },"READ_OCCASIONAL_BANNER_LIST": {
        role: "READ_OCCASIONAL_BANNER_LIST",
        name: ""
    },"UPDATE_ANDROID_RELEASE": {
        role: "UPDATE_ANDROID_RELEASE",
        name: ""
    },"READ_ANDROID_RELEASES_LIST": {
        role: "READ_ANDROID_RELEASES_LIST",
        name: ""
    },"READ_VOWS_LIST": {
        role: "READ_VOWS_LIST",
        name: ""
    },"READ_VOW_STATISTICAL_SUMMARY": {
        role: "READ_VOW_STATISTICAL_SUMMARY",
        name: ""
    },"READ_ACCOMMODATION_HOSTS_LIST": {
        role: "READ_ACCOMMODATION_HOSTS_LIST",
        name: ""
    },"READ_ACCOMMODATION_RESERVATION_PROVINCES_POPULATION_STATISTICAL": {
        role: "READ_ACCOMMODATION_RESERVATION_PROVINCES_POPULATION_STATISTICAL",
        name: ""
    },"READ_TAGS_OFFERS": {
        role: "READ_TAGS_OFFERS",
        name: ""
    },"READ_POST_CATEGORY_TREE": {
        role: "READ_POST_CATEGORY_TREE",
        name: ""
    },"READ_POSTS_LIST": {
        role: "READ_POSTS_LIST",
        name: ""
    },"READ_LOCATION_CATEGORIES_META_DATA_REPORTS": {
        role: "READ_LOCATION_CATEGORIES_META_DATA_REPORTS",
        name: ""
    },"READ_PAYMENT_GATEWAYS_LIST": {
        role: "READ_PAYMENT_GATEWAYS_LIST",
        name: ""
    },"READ_PAYMENT_TRANSACTIONS_LIST": {
        role: "READ_PAYMENT_TRANSACTIONS_LIST",
        name: ""
    },"READ_USERS_LIST": {
        role: "READ_USERS_LIST",
        name: ""
    },"UPDATE_ACCOMMODATION_PERIOD_AUTOMATIC_ACCEPTANCE": {
        role: "UPDATE_ACCOMMODATION_PERIOD_AUTOMATIC_ACCEPTANCE",
        name: ""
    },"READ_MEMORIAL_NOTES_LIST":{
        role:"READ_MEMORIAL_NOTES_LIST",
        name:""
    }
}
